export default __webpack_public_path__ + "static/media/ionicons.0fc454f2.woff";